<template>
    <card-skeleton :loading="loading">
        <router-link
            :to="{ name: routeNames.issueDetails, params: { id: issue.id } }"
            class="d-flex justify-space-between align-center text-decoration-none text-secondary-dark"
        >
            <div class="p-0 w-100">
                <issues-card-meta
                    :subject="issue.subject"
                    :created-at="issue.createdAt"
                    :modified-at="issue.modifiedAt"
                    :status-color="statusType.color"
                    :status-text="statusType.text"
                />
                <issues-content
                    data-id="issueCardContent"
                    :content="issue.body"
                    class-name="mb-0 secondary-text-color text-break font-weight-regular"
                />
                <div class="d-flex mt-6">
                    <v-chip variant="outlined" border="primary opacity-100 sm" size="small" class="mr-2 bg-bg-focused">
                        <span class="text-secondary-dark line-height-lg font-weight-medium">{{ t('inquiry.modifiedLabel') }}</span>
                        <issues-card-date
                            v-if="issue.modifiedAt"
                            data-id="issueCardModifiedDate"
                            :date="issue.modifiedAt"
                            class-name="text-secondary-dark font-weight-medium"
                            :tooltip="t('inquiry.inquiryModified')"
                        />
                    </v-chip>
                </div>
            </div>
            <v-card-item class="pa-0 align-self-start ml-6">
                <v-chip data-id="issuesCardStatus" size="small" :class="{ ['text-size-xs text-white bg-' + statusType.color]: true }">
                    {{ t(`${statusType.text}`) }}
                </v-chip>
            </v-card-item>
        </router-link>
        <v-divider v-if="!isLast" :thickness="2" class="mt-4"></v-divider>
    </card-skeleton>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { routeNames } from '@/router';
import { IIssueCardItem } from '../../types';
import { getIssueStatusType } from '../../helpers';
import IssuesCardDate from '@/features/Issues/components/card/IssuesCardDate.vue';
import IssuesCardMeta from './IssuesCardMeta.vue';
import IssuesContent from './IssuesCardContent.vue';
import CardSkeleton from '@/features/common/components/CardSkeleton.vue';

const props = defineProps<IIssueCardItem>();

const { t } = useI18n();

const statusType = computed(() => getIssueStatusType(props.issue.status));
</script>
